import { supabase } from '@/lib/supabase'
import type { RewardsCycle, RewardsCycleExchangeMetric } from '../types'

export async function getOpenRewardsCycle(accountId: string): Promise<RewardsCycle | null> {
  const id = String(accountId || '').trim()
  if (!id) return null
  const { data, error } = await supabase
    .from('rewards_account_cycles')
    .select('*')
    .eq('account_id', id)
    .eq('status', 'open')
    .order('period_end', { ascending: false })
    .limit(1)
    .maybeSingle()
  if (error) throw error
  if (!data) return null
  const r: any = data
  return {
    id: r.id,
    account_id: r.account_id,
    stripe_subscription_id: r.stripe_subscription_id || null,
    plan_id: r.plan_id || null,
    period_start: r.period_start,
    period_end: r.period_end,
    status: r.status,
    closed_at: r.closed_at || null,
    invoice_id: r.invoice_id || null,
    volume_usdt_total: Number(r.volume_usdt_total || 0),
    commission_estimated_usdt_total: Number(r.commission_estimated_usdt_total || 0),
    commission_confirmed_usdt_total: Number(r.commission_confirmed_usdt_total || 0),
    discount_amount_cents: Number(r.discount_amount_cents || 0),
    discount_currency: String(r.discount_currency || 'BRL'),
    created_at: r.created_at,
    updated_at: r.updated_at,
  }
}

export async function listRewardsCycleMetrics(cycleId: string): Promise<RewardsCycleExchangeMetric[]> {
  const id = String(cycleId || '').trim()
  if (!id) return []
  const { data, error } = await supabase
    .from('rewards_cycle_exchange_metrics')
    .select('*')
    .eq('cycle_id', id)
    .order('exchange', { ascending: true })
  if (error) throw error
  return ((data || []) as any[]).map((r) => ({
    cycle_id: r.cycle_id,
    exchange: r.exchange,
    volume_usdt: Number(r.volume_usdt || 0),
    commission_estimated_usdt: Number(r.commission_estimated_usdt || 0),
    commission_confirmed_usdt: Number(r.commission_confirmed_usdt || 0),
    last_synced_at: r.last_synced_at || null,
    source: r.source || null,
    updated_by: r.updated_by || null,
    created_at: r.created_at,
    updated_at: r.updated_at,
  }))
}

